import { Component } from '@theme/component';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages variant popup behavior.
 * Closes the popup after successful add to cart.
 *
 * @extends Component
 */
export class VariantPopupComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    
    // Listen for successful add to cart events
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.prevActButton = this.querySelector('.variant-popup-act-wrapper button');
    this.addEventListener('change', this.#handleChange.bind(this),{once: true});
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  /**
   * Handles cart add events and closes the popup on successful add
   * @param {CustomEvent} event - The cart add event
   */
  #handleCartAdd = (event) => {
    const eventDetail = event.detail || {};
    const cartData = eventDetail.data || {};
    
    // Only close if this was a successful add operation (not an error or removal)
    const hasAddedProduct = cartData.addedProduct && Object.keys(cartData.addedProduct).length > 0;
    const hasError = cartData.didError;
    const hasRemovedItems = cartData.removedItems && cartData.removedItems.length > 0;
    
    // Close the popup only for successful add operations
    if (hasAddedProduct && !hasError && !hasRemovedItems) {
      this.#closePopup();
    }
  };

  #handleChange = (event) => {
    console.log('handleChange', event);
    if (this.prevActButton && 'disabled' in this.prevActButton) {
      this.prevActButton.disabled = true;
    }
  };

  /**
   * Closes the variant popup dialog
   */
  #closePopup() {
    // Find the dialog component and close it
    const dialogComponent = this.querySelector('dialog-component');
    if (dialogComponent && 'closeDialog' in dialogComponent && typeof dialogComponent.closeDialog === 'function') {
      dialogComponent.closeDialog();
    }
  }
}

// Register the custom element
customElements.define('variant-popup-component', VariantPopupComponent);
